export { default as getSimpleViewOptions } from './getSimpleViewOptions'
